export const padding0MarginRight16Sx = { padding: 0, marginRight: '16px' };

export const iconBtnContainerSx = {
  marginLeft: 'auto',
  padding: '0px 12px 4px 0px',
  display: 'flex',
  flexDirection: 'row',
};
